module.exports = __webpack_public_path__ + "d058c1d67879bebe6620446ee13f6dce.pdf";